import { Injectable } from '@angular/core';
import { SxHttpService } from './sxHttp.service';
import { ItemGeneralListado } from '../../helpers/components/itemClasses/itemListadoGeneral.class';
import { Observable } from 'rxjs/Observable';
import { SxTranslationService } from './translation-service.service';

export interface Comando {
  codComando: string;
  codServicio: string;
  descripcion: string;
}

@Injectable()
export class ComandosService {
  url = 'api/configuracionComando';

  constructor(private sxHttp: SxHttpService, private sxTranslationService: SxTranslationService) { }

  getListadoComandos(): Promise<Comando[]> {
    const url = `${this.url}`;

    return this.sxHttp.get(url)
      .toPromise()
      .then(response => response.json().data as Comando[]);
  }

  getListadoComandosByCodServicio(codServicio: string): Observable<ItemGeneralListado[]> {
    const url = `${this.url}/${codServicio}`;

    return this.sxHttp.get(url)
      .map(response => {
        return response.json().data
          .map(comando => {
            return {
              id: comando.codComando,
              Titulo: comando.codComando,
              Descripcion: comando.descripcion,
              Imagen: this.getIconoComando(comando.codComando),
            };
          }) as ItemGeneralListado[];
      });
  }

  getListadoComandosByCodServicioConTraduccion(codServicio: string): Observable<ItemGeneralListado[]> {
    const url = `${this.url}/${codServicio}`;

    return this.sxHttp.get(url)
      .map(response => {
        return response.json().data
          .map(comando => {
            const translateKey = comando.codServicio + '_' + comando.codComando;
            return {
              id: comando.codComando,
              Titulo: this.sxTranslationService.getResource(translateKey),
              Descripcion: this.sxTranslationService.getResource(translateKey + '_DESCRIPCION'),
              Imagen: this.getIconoComando(comando.codComando),
            };
          }) as ItemGeneralListado[];
      });
  }

  getComando(codServicio: string, codComando: string): Promise<Comando> {
    const url = `${this.url}/${codServicio}/${codComando}`;

    return this.sxHttp.get(url)
      .toPromise()
      .then(response => response.json().data as Comando);
  }

  crearComando(comando: Comando): Promise<Comando> {
    return this.sxHttp.post(this.url, comando)
    .toPromise()
    .then(response => response.json().data as Comando);
  }

  editarComando(codServicio: string, codComando: string, comando: Comando): Promise<Comando> {
    const url = `${this.url}/${codServicio}/${codComando}`;

    return this.sxHttp.post(url, comando)
    .toPromise()
    .then(response => response.json().data as Comando);
  }

  /**
   * Retorna el icono que representa al comando
   *
   * @param codComando El id del comando
   */
  getIconoComando(codComando: string): string {
    const mapping = {
      Alta: 'fa fa-3x fa-user-plus',
      AltaExpress: 'fa fa-3x fa-angle-double-right',
      Blanqueo: 'fa fa-3x fa-user-o',
      Bloqueo: 'fa fa-3x fa-user-times',
      CambioPassword: 'fa fa-3x fa-lock',
      Consulta: 'fa fa-3x fa-question',
      Edicion: 'fa fa-3x fa-pencil-alt-square-o',
      Listado: 'fa fa-3x fa-list',
      Login: 'fa fa-3x fa-sign-in',
      Delete: 'fa fa-3x fa-trash',
      RolesAdministracion: 'fa fa-3x fa-user-secret'
    };
    return mapping[codComando];
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/comandos.service.ts